<script setup lang="ts">
/** TMP084 — Section 78 Return of Allotment of Shares. 두 반복부(shares, allottees) + 누계표.
 *  실제 변수: company, allotment_date, period_*, total_current/additional/accumulated (cash/otherwise/total),
 *  director_name, director_nric, signature_date. Signers 없음(director 직접 서명). */
import { inject, computed } from 'vue';
import { OTC_DOC_CTX } from './otcContext';
import OtcDocVarField from './OtcDocVarField.vue';
import OtcAllotteeTable from './parts/OtcAllotteeTable.vue';

const ctx = inject(OTC_DOC_CTX)!;
const shareRows = computed(() => Array.from({ length: ctx.shareClassCount.value }, (_, i) => i + 1));
</script>

<template>
  <div class="allot-doc">
    <div class="doc-head">
      <div class="doc-meta">COMPANIES ACT 2016 — Section 78</div>
      <div class="doc-company" style="font-size:14px">RETURN OF ALLOTMENT OF SHARES</div>
    </div>

    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Company Name</td><td><OtcDocVarField field-key="company_name" /></td></tr>
        <tr><td class="cdd-lcell">Company Registration No.</td><td><OtcDocVarField field-key="company_registration_no" /></td></tr>
        <tr><td class="cdd-lcell">Date of Allotment</td><td><OtcDocVarField field-key="allotment_date" /></td></tr>
        <tr><td class="cdd-lcell">Period From</td><td><OtcDocVarField field-key="period_start_date" /></td></tr>
        <tr><td class="cdd-lcell">Period To</td><td><OtcDocVarField field-key="period_end_date" /></td></tr>
      </tbody>
    </table>

    <p class="doc-lbl-title">Details of Shares Allotted</p>
    <table class="cdd-tbl">
      <tbody>
        <tr>
          <th style="width:34px">#</th>
          <th>Class of Shares</th>
          <th>Details</th>
          <th>Number Allotted</th>
          <th>Price per Share (RM)</th>
          <th>Total Issued (RM)</th>
          <th style="width:52px"></th>
        </tr>
        <tr v-for="(n, i) in shareRows" :key="n">
          <td>{{ i + 1 }}</td>
          <td><OtcDocVarField :field-key="`share_class_type_${n}`" placeholder="Class of Shares" /></td>
          <td><OtcDocVarField :field-key="`share_class_details_${n}`" placeholder="Details" /></td>
          <td><OtcDocVarField :field-key="`share_class_number_${n}`" placeholder="Number Allotted" /></td>
          <td><OtcDocVarField :field-key="`share_class_price_${n}`" placeholder="Price per Share" /></td>
          <td><OtcDocVarField :field-key="`share_class_total_${n}`" placeholder="Total Issued" /></td>
          <td>
            <button v-if="ctx.shareClassCount.value > 1" class="otc-rowbtn" title="Remove" @click="ctx.removeShareClass(i + 1)">✕</button>
          </td>
        </tr>
        <tr>
          <td colspan="7"><button class="otc-addrow" @click="ctx.addShareClass()">+ Add share class</button></td>
        </tr>
      </tbody>
    </table>

    <p class="doc-lbl-title">Summary of Shares Issued</p>
    <table class="cdd-tbl">
      <tbody>
        <tr>
          <th></th>
          <th>Current Allotment</th>
          <th>Additional</th>
          <th>Accumulated</th>
        </tr>
        <tr>
          <td class="cdd-lcell"><b>Cash</b></td>
          <td><OtcDocVarField field-key="total_current_cash" placeholder="Current — Cash" /></td>
          <td><OtcDocVarField field-key="total_additional_cash" placeholder="Additional — Cash" /></td>
          <td><OtcDocVarField field-key="total_accumulated_cash" placeholder="Accumulated — Cash" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell"><b>Otherwise Than Cash</b></td>
          <td><OtcDocVarField field-key="total_current_otherwise" placeholder="Current — Otherwise" /></td>
          <td><OtcDocVarField field-key="total_additional_otherwise" placeholder="Additional — Otherwise" /></td>
          <td><OtcDocVarField field-key="total_accumulated_otherwise" placeholder="Accumulated — Otherwise" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell"><b>Total</b></td>
          <td><OtcDocVarField field-key="total_current" placeholder="Current — Total" /></td>
          <td><OtcDocVarField field-key="total_additional" placeholder="Additional — Total" /></td>
          <td><OtcDocVarField field-key="total_accumulated" placeholder="Accumulated — Total" /></td>
        </tr>
      </tbody>
    </table>

    <p class="doc-lbl-title">Allottees</p>
    <OtcAllotteeTable :show-id-no="true" :show-total="false" shares-header="No. of Shares Allotted" />

    <p class="doc-p" style="margin-top:14px">
      I confirm that the facts and information stated in this document are true and to the best of my knowledge and belief.
    </p>
    <p class="doc-p"><b>Signed by:</b></p>
    <div class="sig">
      <div>…………………………………………</div>
      <OtcDocVarField field-key="director_name" /><br />
      NRIC: <OtcDocVarField field-key="director_nric" />
      <div style="font-weight:600">Director</div>
    </div>
    <p class="doc-p" style="margin-top:10px"><b>Date:</b> <OtcDocVarField field-key="signature_date" /></p>
  </div>
</template>

<style scoped>
.otc-rowbtn { border:none; background:none; color:#c0392b; cursor:pointer; font-size:12px; }
.otc-addrow { border:1px dashed #9aa4b2; background:#f7f8fa; border-radius:6px; padding:2px 8px; font-size:11px; color:#3182F6; cursor:pointer; }
</style>
